
import React, { Fragment } from 'react';
import { Card, Button, Table, CardTitle, Badge  } from 'reactstrap';

import {  } from 'reactstrap';

const Payments = (props) => {

    return (
          <Fragment>   
         
          <Card body className="mt-5">
          <div>
          <CardTitle className="mb-4 tableTitleBg">Payments</CardTitle>
          </div>
          <Table responsive hover>
          <thead>
          <tr>
          <th>#</th>
          <th>Name</th>
          <th>Service</th>
          <th>Fee</th>
          <th>Status</th>
          <th>Date</th>
          <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr>
          <th scope="row">1</th>
          <td>Emma‎</td>
          <td>Copyright licenses‎	</td>
          <td>$22</td>
          <td> <Badge color="warning">Pending</Badge></td>
          <td>15/04/2020</td>
          <td><Button href="/user-view" className="action-btn" color="success"><span className="fas fa-eye"></span></Button>
          </td>
          </tr>
          <tr>
          <th scope="row">2</th>

          <td>Olivia‎</td>
          <td>dog license</td>
          <td>$30</td>
          <td> <Badge color="info">Transfer</Badge></td>
          <td>16/04/2020</td>
          <td><Button href="/user-view" className="action-btn" color="success"><span className="fas fa-eye"></span></Button>
          </td>
          </tr>
          <tr>
          <th scope="row">3</th>

          <td>Ava Sophia</td>
          <td>Aviation licenses and certifications‎	</td>
          <td>$42</td>
          <td> <Badge color="info">Transfer</Badge></td>
          <td>17/04/2020</td>
          <td><Button href="/user-view" className="action-btn" color="success"><span className="fas fa-eye"></span></Button>
          </td>
          </tr>
          </tbody>
          </Table>
          </Card>      

          </Fragment>
    );
}

export default Payments;
